<template>
  <div class="userList">
    <!-- 账单列表 electricityList-->
    <div class="content">
      <div class="userList-top">
        <span style="font-size:16px">账单列表</span>
        <div class="btns">
          <el-button type="primary" size="mini" @click="exportList" class="last-el-button">报表导出</el-button>
        </div>
      </div>
      <div class="userList-table" :style="{'height':heights+'px'}">
        <el-table :data="tableData" stripe style="width: 100%" :max-height="heights - 20">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="业主名" label="业主名" min-width="80" align="center" />
          <el-table-column prop="合计费用" label="合计费用" min-width="110" align="center" />
          <el-table-column prop="开始时间" label="开始时间" min-width="220" align="center" />
          <el-table-column prop="开始读数" label="开始读数" min-width="110" align="center" />
          <el-table-column prop="用电量" label="用电量" min-width="70" align="center" />
          <el-table-column prop="结束时间" label="结束时间" min-width="220" align="center" />
          <el-table-column prop="结束读数" label="结束读数" min-width="110" align="center" />
          <el-table-column prop="表名" label="表名" min-width="220" align="center" />
          <!-- <el-table-column label="操作时间">
            <template #default="{row}">
              <span>{{row.createTime | date_format}}</span>
            </template>
          </el-table-column> -->

        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>


  </div>
</template>

<script>
  import {findOperatingRecord,findRecordType} from "../../api/zhongshanMeter";
  import resourcesStore from '@/cache/resourcesStore.js'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      downloadTable
    },
    data () {
      return {
        heji: {},//合计
        heights: document.getElementById('app').clientHeight-225,//屏幕高度 - 导航栏高度
        // 操作类型
        recordTypeList: [],
        //加载中
        loading: false,
        form: {},
        //查询
        total: 0,
        currentPage: 1,
        currentSize: 15,
        tableData: [],//表格数据
        datetimeValue: [new Date().getTime()-31*24*60*60*1000,new Date().getTime()],
        startDate: '',//日期 
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          }
        },
        children_params: {},
      };
    },

    mounted () {
      this.children_params=this.$route.query.params;
      this.getDataList() //获取列表数据

    },


    methods: {
      // 获取列表信息
      getDataList () {
        this.children_params.pageIndex=this.currentPage;
        this.children_params.pageSize=this.currentSize;
        var params=this.children_params;
        console.log(params,'params');
        request({url: "/revenueManagement/getElectricityBill.do",method: "get",params}).then(res => {
          console.log(res,11);
          if(res.success) {
            this.tableData=res.data.dataList;
            this.total=res.data.total;
          }
        })
      },



      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-账单列表','.userList-table')
      },

      //分页功能
      newgetNowPageDataList () {
        // 当前页显示
        this.getDataList()
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .box {
    display: flex;
    border: 1px solid #E6E6E6;
    justify-content: space-between;
    margin: 20px;
    height: 100px;
    box-sizing: border-box;
    padding: 20px 0;
  }

  .box .li {
    flex: 1;
    display: flex;
    justify-content: center;
    border-left: 1px solid #E6E6E6;
  }

  .box .li img {
    margin-right: 15px;
  }

  .box .li .t {
    font-size: 24px;
    font-weight: bold;
    color: #1A1A1A;
  }

  .box .li .b {
    font-size: 16px;
    font-weight: 400;
    color: #999;
  }

  .box .li:nth-child(1) {
    border-left: none;
  }

  .userList {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow: hidden;

      .userList-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // height: 50px;
        margin: 0px 20px;
        padding: 20px 0px 12px 0px;
        border-bottom: 2px solid #E6E6E6;

        .user-left {
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            height: 50px;
            line-height: 50px;
            margin-right: 40px;
            cursor: pointer;
            color: #999999;

            &.active {
              color: #359eff;
              font-weight: bold;
              border-bottom: 2px solid #359eff;
            }
          }
        }



      }

      .search {
        display: flex;
        align-items: center;
        margin: 12px 0px 20px 0px;
        position: relative;

        //  left: -3px;
        /deep/.el-form-item {
          margin-bottom: 0px;
        }

        /deep/.el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 350px;
        }
      }

      .userList-table {
        margin: 0px 20px;

        /deep/.el-table th {
          border-right: 1px solid #E6E6E6;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }





      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 8px;
        margin-right: 15px;
      }

    }

    /deep/.el-form-item__label {
      padding: 0px;
    }



  }
</style>